module.exports = __webpack_public_path__ + "static/media/download.fd93ebdb.pdf";